export class ElectronIPCRenderer {
    private _ipcRenderer?: Electron.IpcRenderer;

    private get ipcRenderer() {
        if (!this._ipcRenderer) {
            let {ipcRenderer} = require('electron')
            this._ipcRenderer = ipcRenderer;
        }
        return this._ipcRenderer;
    }

    public async invoke<T>(actionId: string, data?: any): Promise<T> {
        if (!data) {
            data = "";
        }
        return await this.ipcRenderer.invoke(actionId, data);
    }

    public addMessageHandler(channelId: string, callback: (...args: any[]) => void) {
        this.ipcRenderer.on(channelId, (...args: any[]) => {
            args.splice(0, 1);
            callback(...args);
        });
    }

    public removeAllMessageHandlers(channelId: string) {
        this.ipcRenderer.removeAllListeners(channelId);
    }
}

export const ElectronIPCRendererInstance = new ElectronIPCRenderer();